import createTypography, {
  TypographyOptions,
} from '@mui/material/styles/createTypography';
import palette from 'config/theme/palette';

const BASE_FONT_FAMILY = `'Roboto', sans-serif`;

const typographyOptions: TypographyOptions = {
  htmlFontSize: 16,
  fontSize: 14,
  fontFamily: BASE_FONT_FAMILY,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontSize: 24,
    fontWeight: 700,
    lineHeight: 1.24,
  },
  h2: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.24,
  },
  h3: {
    fontSize: 18,
    fontWeight: 600,
    lineHeight: 1.24,
  },
  h4: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: 1.24,
  },
  subtitle1: {
    fontSize: 17,
    fontWeight: 500,
    lineHeight: 1.24,
  },
  subtitle2: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.24,
  },
  body1: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.24,
  },
  body2: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1.24,
  },
  button: {
    fontSize: 13,
    fontWeight: 500,
    lineHeight: '20px',
    textTransform: 'none' as const,
  },
};

const typography = createTypography(palette, typographyOptions);

export default typography;
